/* global Swiper */
// *******************************************************************************
// 1.0 - Hero Slider
// *******************************************************************************

window.addEventListener('spectoCmsContentLoaded', () => {
  window.heroSliderElements = document.querySelectorAll('[data-slider="hero-slider"]');

  window.heroSliderOptions = {
    slidesPerView: 1,
    spaceBetween: 10,
    threshold: 10,
    touchRatio: 0.33,
    speed: 800,
    preloadImages: false,
    watchOverflow: true,
    lazy: {
      loadPrevNext: true,
    },
    effect: 'fade',
    fadeEffect: {
      crossFade: true,
    },
    pagination: {
      el: '.swiper-pagination',
      clickable: true,
    },
  };

  heroSliderElements.forEach((el) => {
    const heroSliderParent = el.closest('.sc-hero-slider');
    const paginationElement = heroSliderParent.querySelector('.swiper-pagination');
    heroSliderOptions.pagination.el = paginationElement;
    // eslint-disable-next-line no-new
    new Swiper(el, heroSliderOptions);
  });
});
